export default {
    getTransferLists: function(state) {
        return state.transferLists;
    },
}
